import Vue from 'vue'
import BaseToastContent from './components/BaseToastContent.vue'
import DownloadSkToastContent from './components/DownloadSkToastContent.vue'

// Base table header styles
const BASE_TH_STYLE = Object.freeze({
  lineHeight: '2',
  textTransform: 'capitalize',
  fontSize: '14px',
  fontWeight: '500',
  color: 'black',
  background: '#F4F4F4',
  borderTop: 'none',
  borderBottom: 'none',
  paddingLeft: '1rem',
  paddingRight: '1rem',
})

const FIRST_TH_STYLE = Object.freeze({
  ...BASE_TH_STYLE,
  boxShadow: `
    inset 1px 0 0 #ddd,
    inset 0 1px 0 #ddd,
    inset 0 -1px 0 #ddd
  `,
  borderRadius: '15px 0 0 0',
})

const MIDDLE_TH_STYLE = Object.freeze({
  ...BASE_TH_STYLE,
  boxShadow: `
    inset 0 1px 0 #ddd,
    inset 0 -1px 0 #ddd
  `,
})

const LAST_TH_STYLE = Object.freeze({
  ...BASE_TH_STYLE,
  boxShadow: `
    inset 0 1px 0 #ddd,
    inset 0 -1px 0 #ddd,
    inset -1px 0 0 #ddd
  `,
  borderRadius: '0 15px 0 0',
  textAlign: 'center',
  minWidth: '150px',
})

const ACTION_COLUMN = Object.freeze({
  key: 'action',
  label: 'Aksi',
  thStyle: LAST_TH_STYLE,
})

export const tableTalentList = [
  { key: 'talent_name', label: 'Nama Talent', thStyle: FIRST_TH_STYLE },
  { key: 'talent_lead', label: 'Talent Lead', thStyle: MIDDLE_TH_STYLE },
  { key: 'device', label: 'Device', thStyle: MIDDLE_TH_STYLE },
  { key: 'assign_at', label: 'Mulai Bertugas', thStyle: MIDDLE_TH_STYLE },
  ACTION_COLUMN,
]

export const tableSKHistory = [
  { key: 'sk_number', label: 'Nomor SK', thStyle: FIRST_TH_STYLE },
  { key: 'apply_at', label: 'Tanggal Mulai', thStyle: MIDDLE_TH_STYLE },
  { key: 'generate_at', label: 'Tanggal Generate', thStyle: MIDDLE_TH_STYLE },
  ACTION_COLUMN,
]

export const tableMultipleAssign = [
  { key: 'talent_name', label: 'Nama Talent', thStyle: FIRST_TH_STYLE },
  ACTION_COLUMN,
]

export const DEFAULT_INCENTIVE = Object.freeze({
  base_salary: '',
  chat_rate_high: '',
  chat_rate_mid: '',
  chat_rate_low: '',
  update_posting_rate: '',
  update_posting_max: 0,
  update_video_rate: '',
  update_video_max: 0,
  update_product_rate: '',
  sales_bonus_percentage: '',
  invoice_rate: '',
  broadcast_rate: '',
  setting_ads_rate: '',
  setting_affiliate_rate: '',
  overtime_rate: '',
  overtime_type: 'hourly',
})

export const SK_CARD_TEXT = Object.freeze({
  CREATE_ASSIGNMENT: 'Penetapan Talent Partner',
  CHANGE_TALENT_LEAD: 'Peralihan Leader',
  CHANGE_TALENT: 'Peralihan Talent',
  CHANGE_PARTNER: 'Peralihan Partner',
  CHANGE_OFFICE: 'Peralihan Kantor',
})

export const TALENT_ACTION = Object.freeze({
  ACTION_ADD: 'Tambah Talent ke Partner',
  ACTION_EDIT_DEVICE: 'Ubah Device',
  ACTION_EDIT_TL: 'Ganti Talent Lead',
  ACTION_EDIT_OFFICE: 'Ganti Kantor',
  ACTION_FORCE_OFF: 'Force Off',
})

const TOAST_CONTENT = {
  BASE: BaseToastContent,
  DOWNLOAD_SK: DownloadSkToastContent,
}

/**
 * Creates toast notification helpers for success/error handling
 */
const createToastNotifier = ({ defaultTitle, defaultIcon, variant }) => (args = {}) => {
  const isObject = typeof args === 'object' && args !== null
  const title = isObject ? (args.title || defaultTitle) : defaultTitle
  const message = isObject
    ? (args.message || (args instanceof Error ? args.message : ''))
    : String(args)
  const options = isObject ? (args.options || {}) : {}
  const timeout = isObject && typeof args.timeout === 'number' ? args.timeout : 2000
  const content = isObject ? (args.content || 'BASE') : 'BASE'
  const onAction = isObject && typeof args.onAction === 'function' ? args.onAction : () => {}

  Vue.$toast(
    {
      component: TOAST_CONTENT[content] || BaseToastContent,
      props: {
        title,
        icon: defaultIcon,
        variant,
        text: message,
        onAction,
        ...options,
      },
    },
    {
      timeout,
      toastClassName: 'lg-rounded-toast',
    },
  )
}

export const showError = createToastNotifier({
  defaultTitle: 'Failure',
  defaultIcon: 'XCircleIcon',
  variant: 'danger',
})

export const showSuccess = createToastNotifier({
  defaultTitle: 'Success',
  defaultIcon: 'CheckCircleIcon',
  variant: 'success',
})
